/**
 * @group Debug
 * @summary Debugging and logging constants
 * 
 * @remarks
 * This constant contains values used for debugging and logging operations,
 * such as string truncation lengths for log output.
 * 
 * @example
 * ```typescript
 * import { DEBUG_CONSTANTS } from '@shared/constants';
 * 
 * const truncated = longString.substring(0, DEBUG_CONSTANTS.MAX_LOG_STRING_LENGTH);
 * ```
 */
export const DEBUG_CONSTANTS = {
  /** Maximum length for truncated log strings (500 characters) */
  MAX_LOG_STRING_LENGTH: 500,
  /** Medium length for truncated log strings (300 characters) */
  MEDIUM_LOG_STRING_LENGTH: 300,
  /** Short length for truncated log strings (20 characters) */
  SHORT_LOG_STRING_LENGTH: 20,
  /** Milliseconds per second (for timestamp conversions) */
  MILLISECONDS_PER_SECOND: 1000,
} as const;

